import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

const LockedProjectRoute = ({
  component: Component,
  project,
  hasToBeLocked,
  redirectPath,
  dispatch,
  ...rest
}) => {
  let isSectionAccessible = true;

  if (!isNil(project)) {
    const isProjectLocked = project.template_locked === 1;
    isSectionAccessible = isProjectLocked === hasToBeLocked;

    // if (!isSectionAccessible) {
    //   console.log('Section Locked !');
    // }
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (!isSectionAccessible) {
          if (props.location.state && props.location.state.fromApp) {
            props.history.goBack();
          } else {
            return (
              <Redirect
                to={{
                  pathname: `/projects/${props.match.params.id}`
                }}
              />
            );
          }
          return null;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default connect(state => ({
  project: state.projects.single.active
}))(LockedProjectRoute);

LockedProjectRoute.propTypes = {
  ...Route.propTypes,
  hasToBeLocked: PropTypes.bool
};

LockedProjectRoute.defaultProps = {
  ...Route.defaultProps,
  hasToBeLocked: false
};



// WEBPACK FOOTER //
// ./src/components/LockedProjectRoute.js